define(['jquery','erv_framework','userway_helpers','tagit',], function ($, Framework, UserwayHelpers) {

	var ERVTagit = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.framework = new Framework();
		self.userwayHelpers = UserwayHelpers;

		if (typeof (Event) === 'function') {
			self.inputEvent = new Event('input', { 'bubbles': true });
		} else {
			self.inputEvent = document.createEvent('Event');
			self.inputEvent.initEvent('input', true, true);
		}

		self.availableCountryTags = [];
		self.initCountryList = function (selector, data) {
			$(selector).each(function () {
				var $this = $(this);
				$this.availableCountryTags = self.availableCountryTags;

				var $currentTagit = $this.tagit({
					availableTags: (data != undefined ? data : []),
					autocomplete: {
						delay: 0,
						minLength: 0,
						autoFocus: true,
						search: function(event, ui) {
							const $tagit = $(event.target).closest('.tagit');
							if ($tagit.find('.tagit-choice').length > 0) {
								event.preventDefault();
								return false;
							}
							const dropdownElement = document.querySelector('.tagit-autocomplete');
							const zoomContainerElement = document.getElementById('erv-body')
							self.userwayHelpers.repositionElementBottomRelativeToInput(event.target, dropdownElement, zoomContainerElement);
						}
					},
					allowSpaces: true,
					allowDuplicates: false,
					allowNewTags: false,
					triggerKeys: ['enter', 'comma', 'tab'],
					tagLimit: 1,
					beforeTagAdded: function (event, ui) {
						return self.tagitBeforeAdded(data, event, ui);
					},
					afterTagAdded: function (event, ui) {
						var tag = self.tagitAfterAdded($this.availableCountryTags, event, ui);

						if (typeof (tag) != 'undefined') {
							$(event.target).val(tag.iso);
						}
						$(this)[0].dispatchEvent(self.inputEvent);

						if (typeof (self.framework.cookies.get(window.ERV.ConfigurationSettings.CookieStrings.GTranslate)) !== 'undefined') {
							$('body').find('.tagit .tagit-choice').addClass('notranslate');
						}

						$(this).parents('.tagit-select').find('.tagit-new input').addClass('hide');
						$(this).find('.ui-autocomplete-input').prop('readonly', true).css('visibility', 'hidden');
						$('.tagit-autocomplete').css('display', 'none');
					},
					afterTagRemoved: function (event, ui) {
						self.tagitAfterRemoved($this.availableCountryTags, event, ui);
						$(this).parents('.tagit-select').find('.tagit-new input').removeClass('hide');
						$(this)[0].dispatchEvent(self.inputEvent);
						$(this).find('.ui-autocomplete-input').prop('readonly', false).css('visibility', 'visible');
					}
				});

				$.each($this.availableCountryTags, function () {
					if ($this.attr('value') === this.iso) {
						$currentTagit.tagit('createTag', this.label);
						return false;
					}
				});

				if ($this.find('.tagit-choice').length > 0) {
					$this.find('.ui-autocomplete-input').prop('readonly', true).css('visibility', 'hidden');
					$('.tagit-autocomplete').css('display', 'none');
				} else {
					$this.find('.ui-autocomplete-input').prop('readonly', false).css('visibility', 'visible');
				}

				self.tagitAutocompleteEvents(true, $this.parent());
			});
		};
	};
	
	ERVTagit.prototype.tagitBeforeAdded = function (data, event, ui) {
		var $targetParent = $(event.target).parent();
		if ($.inArray(ui.tagLabel, data) === -1 || $targetParent.find('.tagit-choice').length > 0) {
			$targetParent.find('.ui-autocomplete-input').val('');
			return false;
		}
		return true;
	}

	ERVTagit.prototype.tagitAfterAdded = function (availableTags, event, ui) {
		var tag = $.grep(availableTags, function (e) { return e.label === ui.tagLabel; })[0],
			self = this;

		self.tagitAfterAddedValidation($(event.target).parent());
		self.tagitAutocompleteEvents(false, $(event.target).parent());

		return tag;
	}

	ERVTagit.prototype.tagitAfterRemoved = function (availableTags, event, ui) {
		var tag = $.grep(availableTags, function (e) { return e.label === ui.tagLabel; })[0],
			self = this;

		if (typeof (tag) != 'undefined') {
			$(event.target).val('');
		}

		self.tagitAfterRemovedValidation($(event.target).parent());
		self.tagitAutocompleteEvents(true, $(event.target).parent());
	}

	ERVTagit.prototype.tagitAfterAddedValidation = function ($targetParent) {
		var $tagitHidden = $targetParent.find('.tagit-hidden-field');
		var $ul = $tagitHidden.parent().find('.tagit.ui-widget');
		$tagitHidden.removeClass('input-validation-error');
		$ul.removeClass('input-validation-error');
		$ul.addClass('input-validation-valid');
		$targetParent.find('.field-validation-error').empty();
	}

	ERVTagit.prototype.tagitAfterRemovedValidation = function ($targetParent) {
		var $tagitHidden = $targetParent.find('.tagit-hidden-field');
		var $ul = $tagitHidden.parent().find('.tagit.ui-widget');

		if ($tagitHidden.val() === '') {
			$tagitHidden.addClass('input-validation-error');
			$ul.addClass('input-validation-error');
			$ul.removeClass('input-validation-valid');
		} else {
			$tagitHidden.removeClass('input-validation-error');
			$ul.removeClass('input-validation-error');
			$ul.addClass('input-validation-valid');
			$targetParent.find('.field-validation-error').empty();
		}
	}

	ERVTagit.prototype.tagitAutocompleteEvents = function (init, $targetParent) {
		var $autoCompleteInput = $targetParent.parents('.field').find('.ui-widget-content.ui-autocomplete-input'),
			$autoCompleteCorner = $targetParent.parents('.field').find('ul.tagit.ui-widget.ui-widget-content.ui-corner-all');

		if (typeof (init) != 'undefined' && !init) {
			$autoCompleteInput.off('click');
			$autoCompleteCorner.off('click');
			$autoCompleteInput.css('visibility', 'hidden');
		} else {
			$autoCompleteInput.on('click', function () {
				if ($(this).closest('.tagit').find('.tagit-choice').length > 0) {
					$('.tagit-autocomplete').css('display', 'none');
					return false;
				}
				$(this).autocomplete('search', $(this).val());
			});

			$autoCompleteCorner.on('click', function () {
				var $tagit = $(this).closest('.tagit');
				if ($tagit.find('.tagit-choice').length > 0) {
					$('.tagit-autocomplete').css('display', 'none');
					return false;
				}
				$autoCompleteInput.autocomplete('search', '');
			});

			if ($targetParent.find('.tagit-choice').length > 0) {
				$autoCompleteInput.css('visibility', 'hidden');
			} else {
				$autoCompleteInput.css('visibility', 'visible');
			}
			$('.tagit-autocomplete').css('display', 'none');
		}
	}

	ERVTagit.prototype.init = function () {
		var self = this;

		self.$ervBody.find('.tagit .ui-widget-content.ui-autocomplete-input').on('blur', function () {
			var $tagitElement = $(this).parents('.form-element');
			var $tagitUl = $tagitElement.find('ul.tagit');
			var $hiddenField = $tagitElement.find('.tagit-hidden-field');

			if ($hiddenField.data('val') === true && ($hiddenField.length === 0 || $hiddenField.val() === '')) {
				$hiddenField.addClass('input-validation-error');
				$tagitUl.addClass('input-validation-error');
				$tagitUl.removeClass('input-validation-valid');
			} else {
				$hiddenField.removeClass('input-validation-error');
				$tagitUl.removeClass('input-validation-error');
				$tagitUl.addClass('input-validation-valid');
			}
		});

		self.initCountryList('.tagme', self.$ervBody.find('.country-list').first().find('li').map(function () {
				self.availableCountryTags.push({ label: $(this).text(), iso: $(this).data('value') });
				return $(this).text();
			})
		);
	}

	return ERVTagit;
});
